export const makes = [
  {
    value: "1",
    label: "ALFA ROMEO",
  },
  {
    value: "2",
    label: "AUDI",
  },
  {
    value: "3",
    label: "BMW",
  },
  {
    value: "4",
    label: "CHEVROLET",
  },
  {
    value: "5",
    label: "CHRYSLER",
  },
  {
    value: "6",
    label: "CITROEN",
  },
  {
    value: "7",
    label: "DAEWOO",
  },
  {
    value: "8",
    label: "DAIHATSU",
  },
  {
    value: "9",
    label: "DODGE",
  },
  {
    value: "10",
    label: "FIAT",
  },
  {
    value: "11",
    label: "FORD",
  },
  {
    value: "12",
    label: "HONDA",
  },
  {
    value: "13",
    label: "HYUNDAI",
  },
  {
    value: "14",
    label: "ISUZU",
  },
  {
    value: "15",
    label: "JAGUAR",
  },
  {
    value: "16",
    label: "JEEP",
  },
  {
    value: "17",
    label: "KIA",
  },
  {
    value: "18",
    label: "LANCIA",
  },
  {
    value: "19",
    label: "LAND ROVER",
  },
  {
    value: "20",
    label: "LEXUS",
  },
  {
    value: "21",
    label: "MAZDA",
  },
  {
    value: "22",
    label: "MERCEDES",
  },
  {
    value: "23",
    label: "MITSUBISHI",
  },
  {
    value: "24",
    label: "NISSAN",
  },
  {
    value: "25",
    label: "OPEL",
  },
  {
    value: "26",
    label: "PEUGEOT",
  },
  {
    value: "27",
    label: "PONTIAC",
  },
  {
    value: "28",
    label: "PORSCHE",
  },
  {
    value: "29",
    label: "RENAULT",
  },
  {
    value: "30",
    label: "ROVER",
  },
  {
    value: "31",
    label: "SAAB",
  },
  {
    value: "32",
    label: "SEAT",
  },
  {
    value: "33",
    label: "SKODA",
  },
  {
    value: "34",
    label: "SMART",
  },
  {
    value: "35",
    label: "SUBARU",
  },
  {
    value: "36",
    label: "SUZUKI",
  },
  {
    value: "37",
    label: "TOYOTA",
  },
  {
    value: "38",
    label: "VOLKSWAGEN",
  },
  {
    value: "39",
    label: "VOLVO",
  },
  {
    value: "40",
    label: "IVECO",
  },
  {
    value: "41",
    label: "FSO",
  },
  {
    value: "42",
    label: "MAZ",
  },
  {
    value: "43",
    label: "LADA",
  },
  {
    value: "44",
    label: "CORVETTE",
  },
  {
    value: "45",
    label: "DACIA",
  },
  {
    value: "46",
    label: "DAIMLER",
  },
  {
    value: "47",
    label: "LUBLIN",
  },
  {
    value: "48",
    label: "MAN",
  },
  {
    value: "49",
    label: "FERRARI",
  },
  {
    value: "50",
    label: "ARO",
  },
  {
    value: "51",
    label: "HONKER",
  },
  {
    value: "52",
    label: "CADILLAC",
  },
  {
    value: "53",
    label: "GAZ",
  },
  {
    value: "54",
    label: "INTRALL",
  },
  {
    value: "55",
    label: "MAYBACH",
  },
  {
    value: "56",
    label: "MINI",
  },
  {
    value: "57",
    label: "MITSUBISHI FUSO",
  },
  {
    value: "58",
    label: "RENAULT TRUCKS",
  },
  {
    value: "59",
    label: "ROLLS-ROYCE",
  },
  {
    value: "60",
    label: "SSANGYONG",
  },
  {
    value: "61",
    label: "HUMMER",
  },
  {
    value: "62",
    label: "TATA",
  },
  {
    value: "63",
    label: "LDV",
  },
  {
    value: "64",
    label: "ABARTH",
  },
  {
    value: "65",
    label: "INFINITI",
  },
  {
    value: "66",
    label: "S.A.M.",
  },
  {
    value: "67",
    label: "MASERATI",
  },
  {
    value: "68",
    label: "DS",
  },
  {
    value: "69",
    label: "DAF",
  },
  {
    value: "70",
    label: "BENTLEY",
  },
  {
    value: "71",
    label: "CUPRA",
  },
  {
    value: "72",
    label: "ASTON MARTIN",
  },
  {
    value: "73",
    label: "TESLA",
  },
  {
    value: "74",
    label: "ALPINE",
  },
  {
    value: "75",
    label: "LEVC",
  },
  {
    value: "76",
    label: "DANGEL",
  },
  {
    value: "77",
    label: "DFSK",
  },
  {
    value: "78",
    label: "MAXUS",
  },
  {
    value: "79",
    label: "SKYWELL",
  },
  {
    value: "992",
    label: "SCANIA",
  },
];
